// extracted by mini-css-extract-plugin
export default {"espacamento":"TextoGrupo_espacamento__uEZl1","label":"TextoGrupo_label__JJ4Fi"};